import Hook from "../../utils/hook"
import { fetchJson } from "../../utils/fetch"
import { decodeBase64Url } from "../../utils/base64"
import {
  credentialToJson,
  getAuthenticatorNameFromCredential,
} from "../../utils/credentials"
import { osName } from "../../utils/os"

function getPasskeyOptionsPublicKey(options) {
  const publicKey = options.publicKey
  publicKey.challenge = decodeBase64Url(publicKey.challenge)
  publicKey.user.id = decodeBase64Url(publicKey.user.id)
  publicKey.excludeCredentials = (publicKey.excludeCredentials || []).map(
    (credential) => ({
      ...credential,
      id: decodeBase64Url(credential.id),
    })
  )
  return publicKey
}

export const SettingsPagePasskey = Hook(`SettingsPagePasskey`, {
  values: {
    loadEventName: String,
    optionsUrl: String,
    registerUrl: String,
    errorMessage: String,
    addedMessage: String,
    alreadyAddedMessage: String,
  },
  targets: [`button`],
  actions: [
    {
      name: `buttonClick`,
      targets: `button`,
      type: `click`,
    },
  ],
  abortController: null,

  async buttonClickAction() {
    try {
      this.abortController?.abort()
      this.abortController = new AbortController()

      const optionsResponse = await fetchJson(this.optionsUrlValue)
      const options = await optionsResponse.json()
      const credential = await navigator.credentials.create({
        publicKey: getPasskeyOptionsPublicKey(options),
        signal: this.abortController.signal,
      })

      let passkeyLabel = osName()
      const authenticatorName = getAuthenticatorNameFromCredential(credential)

      if (passkeyLabel && authenticatorName)
        passkeyLabel += ` (${authenticatorName})`
      else if (authenticatorName) passkeyLabel = authenticatorName

      await fetchJson(this.registerUrlValue, {
        credential: credentialToJson(credential),
        label: passkeyLabel || `Passkey`,
      })

      this.pushEvent(this.loadEventNameValue)

      this.putFlash({
        type: `info`,
        text: this.addedMessageValue,
      })
    } catch (err) {
      if (err.name == `InvalidStateError`)
        this.putFlash({
          type: `info`,
          text: this.alreadyAddedMessageValue,
        })
      else
        this.putFlash({
          type: `error`,
          text: this.errorMessageValue,
        })
    }
  },
})
